










import LoadingOverlay from "@/components/shared/LoadingOverlay.vue";
import Navbar from "@/components/shared/Navbar.vue";
import { Component, Vue } from "vue-property-decorator";
import { me } from "./graphql/auth";
import { allConferences } from "./graphql/conference";
import { allContent } from "./graphql/content";
import { allCommitteeMembers, invitedSpeakers } from "./graphql/members";
import { allTopics } from "./graphql/topics";

@Component({
  components: { Navbar, LoadingOverlay },
  apollo: {
    allTopics() {
      return { query: allTopics, skip: true, variables: { conference: "" } };
    },
    allCommitteeMembers() {
      return {
        query: allCommitteeMembers,
        skip: true,
        variables: { conference: "" },
      };
    },
    invitedSpeakers() {
      return {
        query: invitedSpeakers,
        skip: true,
        variables: { conference: "" },
      };
    },
    allContent() {
      return { query: allContent, skip: true, variables: { conference: "" } };
    },
    allConferences() {
      return {
        query: allConferences,
        skip: true,
      };
    },
    me() {
      return { query: me, skip: true, variables: { conference: "" } };
    },
  },
})
export default class App extends Vue {
  async getTopics() {
    this.$apollo.queries.allTopics.setVariables({
      conference: this.conference,
    });
    this.$apollo.queries.allTopics.skip = false;
    await this.$apollo.queries.allTopics.refetch();
  }

  async getContent() {
    this.$apollo.queries.allContent.setVariables({
      conference: this.conference,
    });
    this.$apollo.queries.allContent.skip = false;
    await this.$apollo.queries.allContent.refetch();
  }
  async getConferences() {
    this.$apollo.queries.allConferences.skip = false;
    await this.$apollo.queries.allConferences.refetch();
  }

  async getAllCommittees() {
    this.$apollo.queries.allCommitteeMembers.setVariables({
      conference: this.conference,
    });
    this.$apollo.queries.allCommitteeMembers.skip = false;
    await this.$apollo.queries.allCommitteeMembers.refetch();
  }

  async getInvitedSpeakers() {
    this.$apollo.queries.invitedSpeakers.setVariables({
      conference: this.conference,
    });
    this.$apollo.queries.invitedSpeakers.skip = false;
    await this.$apollo.queries.invitedSpeakers.refetch();
  }

  get conference() {
    return this.$store.getters.getConferenceId;
  }

  get isAdmin() {
    return this.$store.getters.isAdmin;
  }

  get showNav() {
    return this.$store.getters.showNav;
  }

  isLoading = false;

  async beforeMount() {
    this.isLoading = true;
    await this.getConferences();
    // @ts-ignore
    this.$store.commit("setConferences", this.allConferences);
    const mostRecentConference =
      // @ts-ignore
      this.allConferences[this.allConferences.length - 1];
    this.$store.commit(
      "setConference",
      // @ts-ignore
      mostRecentConference
    );
    localStorage.setItem("conference", JSON.stringify(mostRecentConference));

    const token: any = localStorage.getItem("token");
    this.$apollo.queries.me.setVariables({
      conference: this.conference._id,
    });
    this.$apollo.queries.me.skip = false;
    await this.$apollo.queries.me
      .refetch()
      .then((res) => {
        this.$store.commit("setUser", res.data.me);
        this.$store.commit("setToken", token);
        this.$store.commit("authenticate", true);
      })
      .catch(() => {
        console.log("error logging in");
      });

    await this.getContent();
    // @ts-ignore
    this.$store.commit("setContent", this.allContent);
    this.isLoading = false;
    await this.getAllCommittees();
    // @ts-ignore
    this.$store.commit("setCommittee", this.allCommitteeMembers);

    await this.getInvitedSpeakers();
    // @ts-ignore
    this.$store.commit("setInvitedSpeakers", this.invitedSpeakers);

    await this.getTopics();
    // @ts-ignore
    this.$store.commit("setTopics", this.allTopics);
  }
}
